export const useTestExecutionFavorites = (
  addFavorite,
  removeFavorite,
  user
) => {
  const addToFavoritesHandler = (event, testId) => {
    event.stopPropagation();
    addFavorite({
      variables: { testId: testId, uid: user._id },
    })
      .then(() => {
        // Success handled silently
      })
      .catch((error) => {
        window.flash(
          'Failed to add test execution to favorites. Please try again later',
          'error'
        );
      });
  };

  const removeFromFavoritesHandler = (event, testId) => {
    event.stopPropagation();
    removeFavorite({
      variables: { testId: testId, uid: user._id },
    })
      .then(() => {
        // Success handled silently
      })
      .catch((error) => {
        window.flash(
          'Failed to remove test execution from favorites. Please try again later',
          'error'
        );
      });
  };

  return {
    addToFavoritesHandler,
    removeFromFavoritesHandler,
  };
};
